import { socials } from "../../../../config/socials";

export const socialsService = {
  getSocials(variant = "desktop", colorScheme = "light") {
    return socials
      .filter((social) => social.visible?.[variant])
      .map((social) => {
        const useIcons =
          colorScheme === "dark" ||
          (
            colorScheme === "system" &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
          );

        return {
          ...social,

          icon: useIcons ? social.icon : null,
          image: useIcons ? null : social.image,
        };
      })
      .sort((a, b) => (a.priority ?? 999) - (b.priority ?? 999));
  },

  getSocial(id) {
    return socials.find((social) => social.id === id) ?? null;
  },
};